export function findValueInCatalog(catalog = [], id){
  const itemInCatalog = catalog.find(item => item.catalogId === id)
  if(itemInCatalog)
    return itemInCatalog.nameUkr
  return ''
}

export const parseDataForms = (type, data) => {
  switch (type) {
    case 'GeneralInformation':
      return {
        firstName: data.name,
        surName: data.surname,
        patronymic: data.patronymicName,
        stateCode: data.stateCode,
        dateBirthday: data.birthDay,
        noPatronymic: data.noPatronymic
      }
    case 'Documents':
      return {
        typeDocument: data.docTypeId,
        numDoc: data.docNumber,
        seria: data.docSeries,
        count: data.dependentsNumber,
        region: data.liveRegionId,
        education: data.educationId,
        marital: data.maritalId,
        dateDoc: data.docIssueDate,
        birthDay: data.birthDay,
        clickedDocType: data.clickedDocType
      }
    case 'Work': 
      return {
        workExpiriens: data.employmentMonth,
        avgIncome: data.salary,
        summCredit: data.amount,
        position_level: data.positionId,
        region: data.jobRegionId,
        employment_type: data.jobCategoryId,
        ent_segment: data.entSegmentCode,
        military_status_id: data.militaryStatusId,
      }
    default:
      break;
  }
}

export const checkNotEmptyValue = value => {

  switch (typeof value) {
    case 'string': return value.length !== 0
    case 'number': return value > 0
    case 'boolean': return true
  
    default: return false
  }

}